const itemCount = {
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '17.5px',
  letterSpacing: '2.1px'
}

const title = {
  fontSize: '24px',
  lineHeight: '30px',
  fontWeight: '325',
  textTransform: 'none',
  'screen-medium': {
    fontSize: '32px',
    lineHeight: '40px',
  }
}

const loyaltyProductsGrid = {
  itemCount,
  title
}

export default loyaltyProductsGrid
